// @ts-ignore
import NAdeDE from "src/template/NA/Revenue_Calculator_New_Product_Template_NA-de-DE.xlsx"
import NAenCA from "src/template/NA/Revenue_Calculator_New_Product_Template_NA-en-CA.xlsx"
import NAenUS from "src/template/NA/Revenue_Calculator_New_Product_Template_NA-en-US.xlsx"
import NAesES from "src/template/NA/Revenue_Calculator_New_Product_Template_NA-es-ES.xlsx"
import NAfrFR from "src/template/NA/Revenue_Calculator_New_Product_Template_NA-fr-FR.xlsx"
import NAhiIN from "src/template/NA/Revenue_Calculator_New_Product_Template_NA-hi-IN.xlsx"
import NAitIT from "src/template/NA/Revenue_Calculator_New_Product_Template_NA-it-IT.xlsx"
import NAjaJP from "src/template/NA/Revenue_Calculator_New_Product_Template_NA-ja-JP.xlsx"
import NAkoKR from "src/template/NA/Revenue_Calculator_New_Product_Template_NA-ko-KR.xlsx"
import NAptBR from "src/template/NA/Revenue_Calculator_New_Product_Template_NA-pt-BR.xlsx"
import NAtaIN from "src/template/NA/Revenue_Calculator_New_Product_Template_NA-ta-IN.xlsx"
import NAzhCN from "src/template/NA/Revenue_Calculator_New_Product_Template_NA-zh-CN.xlsx"
import NAzhTW from "src/template/NA/Revenue_Calculator_New_Product_Template_NA-zh-TW.xlsx"
import EUarAE from "src/template/EU/Revenue_Calculator_New_Product_Template_EU-ar-AE.xlsx"
import EUdeDE from "src/template/EU/Revenue_Calculator_New_Product_Template_EU-de-DE.xlsx"
import EUenAE from "src/template/EU/Revenue_Calculator_New_Product_Template_EU-en-AE.xlsx"
import EUenGB from "src/template/EU/Revenue_Calculator_New_Product_Template_EU-en-GB.xlsx"
import EUesES from "src/template/EU/Revenue_Calculator_New_Product_Template_EU-es-ES.xlsx"
import EUfrFR from "src/template/EU/Revenue_Calculator_New_Product_Template_EU-fr-FR.xlsx"
import EUhiIN from "src/template/EU/Revenue_Calculator_New_Product_Template_EU-hi-IN.xlsx"
import EUitIT from "src/template/EU/Revenue_Calculator_New_Product_Template_EU-it-IT.xlsx"
import EUjaJP from "src/template/EU/Revenue_Calculator_New_Product_Template_EU-ja-JP.xlsx"
import EUkoKR from "src/template/EU/Revenue_Calculator_New_Product_Template_EU-ko-KR.xlsx"
import EUnlNL from "src/template/EU/Revenue_Calculator_New_Product_Template_EU-nl-NL.xlsx"
import EUplPL from "src/template/EU/Revenue_Calculator_New_Product_Template_EU-pl-PL.xlsx"
import EUptBR from "src/template/EU/Revenue_Calculator_New_Product_Template_EU-pt-BR.xlsx"
import EUsvSE from "src/template/EU/Revenue_Calculator_New_Product_Template_EU-sv-SE.xlsx"
import EUfrBE from "src/template/EU/Revenue_Calculator_New_Product_Template_EU-fr-BE.xlsx"
import EUtaIN from "src/template/EU/Revenue_Calculator_New_Product_Template_EU-ta-IN.xlsx"
import EUtrTR from "src/template/EU/Revenue_Calculator_New_Product_Template_EU-tr-TR.xlsx"
import EUzhCN from "src/template/EU/Revenue_Calculator_New_Product_Template_EU-zh-CN.xlsx"
import EUzhTW from "src/template/EU/Revenue_Calculator_New_Product_Template_EU-zh-TW.xlsx"
import FEdeDE from "src/template/FE/Revenue_Calculator_New_Product_Template_FE-de-DE.xlsx"
import FEenAU from "src/template/FE/Revenue_Calculator_New_Product_Template_FE-en-AU.xlsx"
import FEenSG from "src/template/FE/Revenue_Calculator_New_Product_Template_FE-en-SG.xlsx"
import FEenUS from "src/template/FE/Revenue_Calculator_New_Product_Template_FE-en-US.xlsx"
import FEesES from "src/template/FE/Revenue_Calculator_New_Product_Template_FE-es-ES.xlsx"
import FEfrFR from "src/template/FE/Revenue_Calculator_New_Product_Template_FE-fr-FR.xlsx"
import FEitIT from "src/template/FE/Revenue_Calculator_New_Product_Template_FE-it-IT.xlsx"
import FEjaJP from "src/template/FE/Revenue_Calculator_New_Product_Template_FE-ja-JP.xlsx"
import FEkoKR from "src/template/FE/Revenue_Calculator_New_Product_Template_FE-ko-KR.xlsx"
import FEzhCN from "src/template/FE/Revenue_Calculator_New_Product_Template_FE-zh-CN.xlsx"
import FEzhTW from "src/template/FE/Revenue_Calculator_New_Product_Template_FE-zh-TW.xlsx"
import i18next from "i18next";


export const newProductTemplate = (): any => {
    const templateMap: Record<string, Record<string, any>> = {
        "USAmazon": {
            "de-DE": NAdeDE,
            "en-CA": NAenCA,
            "en-US": NAenUS,
            "es-ES": NAesES,
            "fr-FR": NAfrFR,
            "hi-IN": NAhiIN,
            "it-IT": NAitIT,
            "ja-JP": NAjaJP,
            "ko-KR": NAkoKR,
            "pt-BR": NAptBR,
            "ta-IN": NAtaIN,
            "zh-CN": NAzhCN,
            "zh-TW": NAzhTW,
            // todo vi_vn th_th use en_US
            "vi-VN": NAenUS,
            "th-TH": NAenUS,
            "default": NAenUS,
        },
        "EUAmazon": {
            // todo ar nl pl sv tr use en_GB
            "ar-AE": EUenGB,
            "de-DE": EUdeDE,
            "en-AE": EUenAE,
            "en-GB": EUenGB,
            "es-ES": EUesES,
            "fr-FR": EUfrFR,
            "hi-IN": EUhiIN,
            "it-IT": EUitIT,
            "ja-JP": EUjaJP,
            "ko-KR": EUkoKR,
            "nl-NL": EUenGB,
            "pl-PL": EUenGB,
            "pt-BR": EUptBR,
            "sv-SE": EUenGB,
            "fr-BE": EUfrBE,
            "ta-IN": EUtaIN,
            "tr-TR": EUenGB,
            "zh-CN": EUzhCN,
            "zh-TW": EUzhTW,
            "default": EUenGB,
        },
        "JPAmazon": {
            "de-DE": FEdeDE,
            "en-AU": FEenAU,
            "en-SG": FEenSG,
            "en-US": FEenUS,
            "es-ES": FEesES,
            "fr-FR": FEfrFR,
            "it-IT": FEitIT,
            "ja-JP": FEjaJP,
            "ko-KR": FEkoKR,
            "zh-CN": FEzhCN,
            "zh-TW": FEzhTW,
            "default": FEenUS,
        }
    }
    return templateMap["USAmazon"] ? templateMap["USAmazon"][i18next.language] ?? templateMap["USAmazon"]["default"] : templateMap["USAmazon"]["default"];
}